import "./Home.css"
import React from "react"

const Home = () => {
    return (
        <p className="intro-text">Welcome to My Library app</p>
    )
}

export default Home